// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3FAPo","backdropPopup":"Modal_backdropPopup__3ufe8","modal":"Modal_modal__P3_V5"};